/*
	orval generator will use this HTTP client for all requests
	Can be reimplemented with whatever library/fetch we want in the future
*/
import Axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { token } from '../api/Agent';

export const axios = Axios.create({ baseURL: process.env.BASEURL });

axios.interceptors.request.use((request) => ({
	...request,
	headers: {
		...request.headers,
		...(token() && request.headers
			? {
					Authorization: `Bearer ${token()}`
			  }
			: {})
	}
}));

export type ErrorType<Error> = AxiosError<Error>;
export type ApiservError<T> = ErrorType<T>;

export const request = async <T>(config: AxiosRequestConfig, options?: AxiosRequestConfig): Promise<T> => {
	const source = Axios.CancelToken.source();
	const { data } = await axios({
		...config,
		...options,
		cancelToken: source.token
	});
	return data;
};
